module.exports = __webpack_public_path__ + "static/images/containers/ChallengesPromo/images/places.RU.719a3fcf.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengesPromo/images/places.RU.png
// module id = 2875
// module chunks = 11